import { useAuthContext } from '../contexts/auth-context';
import { BusinessProfile } from '../utils/business-profile';

interface ShopDetails {
	shopId: string;
	locationId: string;
	shopName: string;
	locationName: string;
	businessType: string;
	/**
	 * The active location's business profile (location-business-profile D10):
	 * what staff and services are called, and whether every bill line needs a
	 * staff member. With nothing stored yet it replays the portal's behaviour
	 * from before profiles existed, so a restaurant session never flashes a
	 * Services entry.
	 */
	profile: BusinessProfile;
}

export function useShopDetails(): ShopDetails {
	let { shopId, locationId, profile } = useAuthContext();

	if (!shopId) {
		shopId = localStorage.getItem('shopId')!;
	}

	if (!locationId) {
		locationId = localStorage.getItem('locationId')!;
	}

	const shopName = localStorage.getItem('shopName') || 'Hairways';
	const locationName = localStorage.getItem('locationName') || '';
	// A session started before this field existed has nothing stored; treating
	// that as SALON keeps the portal exactly as it was until the next switch.
	const businessType = localStorage.getItem('businessType') || 'SALON';

	return {
		shopId,
		locationId,
		shopName,
		locationName,
		businessType,
		profile,
	};
}
